import {
  COMPANY_SETUP_CONFIGURATION_BEGIN,
  COMPANY_SETUP_CONFIGURATION_SUCCESS,
  COMPANY_SETUP_CONFIGURATION_FAILURE,
  COMPANY_SETUP_CONFIGURATION_DISMISS_ERROR,
} from './constants';



import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function setupConfiguration(company, args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: COMPANY_SETUP_CONFIGURATION_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      axios.post(SERVER_PATH + '/companies/edit', {
        company:company
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          dispatch({
            type: COMPANY_SETUP_CONFIGURATION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: COMPANY_SETUP_CONFIGURATION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSetupConfigurationError() {
  return {
    type: COMPANY_SETUP_CONFIGURATION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMPANY_SETUP_CONFIGURATION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        setupConfigurationPending: true,
        setupConfigurationError: null,
      };

    case COMPANY_SETUP_CONFIGURATION_SUCCESS:
      // The request is success
      return {
        ...state,
        setupConfigurationPending: false,
        setupConfigurationError: null,
      };

    case COMPANY_SETUP_CONFIGURATION_FAILURE:
      // The request is failed
      return {
        ...state,
        setupConfigurationPending: false,
        setupConfigurationError: action.data.error,
      };

    case COMPANY_SETUP_CONFIGURATION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        setupConfigurationError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/company/redux/setupConfiguration.js